import { render, staticRenderFns } from "./recovery_password_page.vue?vue&type=template&id=2b83cb0e&"
import script from "./recovery_password_page.vue?vue&type=script&lang=js&"
export * from "./recovery_password_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports